const iconPaths = {
  add: {
    grey: "/icon-add@3x.png",
    white: "/icon-add-white@3x.png",
  },
  back: {
    black: "/back@3x.png",
  },
  close: {
    grey: "/ic-close-24@3x.png",
    black: "/ic-close-black@3x.png",
  },
  reload: "/shape.svg",
  filter: {
    black: "/icon-filter-black@3x.png",
    blue: "/icon-filter-blue@3x.png",
  },
  arrow: {
    up: {
      filter_black: "/filter_arrow_up.svg",
      black: "/arrow-up-black.svg",
    },

    down: {
      filter_black: "/filter_arrow_down.svg",
      black: "/arrow-down-black@3x.png",
      blue: "/arrow-down-blue@3x.png",
    },
    left: {
      black: "/arrows-chevron-left@3x.png",
    },
    right: {
      black: "/arrows-chevron-right@3x.png",
    },
  },
  radio: {
    check: "/radio_check.svg",
    unCheck: "/radio_uncheck.svg",
  },
  squareArrow: {
    left: {
      black: "/arrow-left-black@3x.png",
    },
    right: {
      black: "/arrow-right-black@3x.png",
    },
  },
  saleLocation: {
    public: "/em-location-on@3x.png",
    private: "/em-location-off@3x.png",
  },
  saleState: {
    total: {
      off: "/em-search-total-off@3x.png",
      on: "/em-search-total-on@3x.png",
    },
    visible: {
      off: "/em-search-visible-off@3x.png",
      on: "/em-search-visible-on@3x.png",
    },
    invisible: {
      off: "/em-search-invisible-off@3x.png",
      on: "/em-search-invisible-on@3x.png",
    },
    done: {
      off: "/em-search-done-off@3x.png",
      on: "/em-search-done-on@3x.png",
      coolGrey: "/em-search-done-cool-grey@3x.png",
    },
  },
  block: {
    grey: "/ic-block-grey@3x.png",
  },
  delete: {
    grey: "/icon-delete-grey@3x.png",
    coolGrey: "/ic-delete-cool-grey@3x.png",
  },
  menu: {
    horizontal: {
      black: "/icon-more-horiz-black@3x.png",
      grey: "/icon-more-horiz-black@3x.png",
      blue: "icon-more-horiz-blue@3x.png",
    },
  },
  search: {
    grey: "/ic-search-grey@3x.png",
    black: "/ic-search-20@3x.png",
  },
  edit: {
    grey: "/ic-edit-grey@3x.png",
    coolGrey: "/ic-edit-cool-grey@3x.png",
  },
  share: {
    grey: "/icon-share-grey@3x.png",
    coolGrey: "/icon-share-cool-grey@3x.png",
  },
  report: {
    grey: "/icon-report-grey@3x.png",
    blue: "/icon-report-blue@3x.png",
    coolGrey: "/icon-report-cool-grey@3x.png",
  },
  note: {
    grey: "/icon-note-grey@3x.png",
    blue: "/icon-note-blue@3x.png",
    coolGrey: "/icon-note-cool-grey@3x.png",
  },
  aiPost: {
    grey: "/icon-ai-post-grey@3x.png",
    coolGrey: "/icon-ai-post-cool-grey@3x.png",
  },
  saleNoData: "/icon-sale-no-data.png",
  refresh: {
    grey: "/icon-refresh-grey@3x.png",
  },
  mapToggle: {
    map: {
      grey: "/icon-map-grey@3x.png",
    },
    list: {
      grey: "/icon-list-grey@3x.png",
    },
  },
  check: {
    blue: "/icon-check-blue@3x.png",
  },
  alert: {
    info: "/check-mark@3x.png",
    error: "/ic-exceptionerror-50@3x.png",
    // Figma Icon/Normal/Circle Exclamation (신고 모달 등) — 에셋 없으면 error 사용
    circleExclamation: "/ic-circle-exclamation@3x.png",
  },
  info: {
    red: "/icon-info-30@3x.png",
  },
  membership: {
    alert: "/img-membership-alert.png",
  },
  blankImage: {
    sale: "/sale-no-image-placeholder.png",
  },
  estateType: {
    all: "/icon-estate-type-all.svg",
    commercial: "/icon-estate-type-commercial.svg",
    land: "/icon-estate-type-land.svg",
    market: "icon-estate-type-market.svg",
    group: "/icon-estate-type-group.svg",
    officetell: "icon-estate-type-officetell.svg",
    factory: "icon-estate-type-factory.svg",
    apartment: "icon-estate-type-apartment.svg",
    accommondation: "icon-estate-type-accommondation.svg",
    single: "icon-estate-type-single.svg",
    building_town: "/building_town.svg",
  },
  logo: "/ic-main-logo-copy-2.svg",
  nameCard: {
    pro: "/Namecard-ProBadge_3@3x.png",
  },

  list: "/web-format-list-bulleted.svg",
  message: {
    black: "/ic-message-black@3x.png",
  },
  person: {
    black: "/ic-person-black@3x.png",
  },
  attach: {
    black: "/ic-attach-black@3x.png",
  },
  trash: {
    black: "/icon-delete-grey@3x.png",
  },
  setting: {
    black: "/icon-more-horiz-black@3x.png",
  },

  empty: {
    list: "/empty_list.svg",
  },
  idVerification: {
    blue: "/id-verification@3x.png",
  },
  ownerVerification: {
    info: "/ov-info-illustration.png",
    badge: "/verified_check.svg",
  },
};

// 메신저 전용 아이콘 — Figma API로 다운받아 public/images/icon/messager/ 에 저장한 에셋만 사용
const messagerIconPaths = {
  trash: "messager/trash@3x.png",
  setting: "messager/setting@3x.png",
  close: "messager/close@3x.png",
  chevronLeft: "messager/chevron-left@3x.png",
  chevronRight: "messager/chevron-right@3x.png",
  chat: "messager/chat@3x.png",
  person: "messager/person@3x.png",
  moreVertical: "messager/more-vertical@3x.png",
  attach: "messager/attach@3x.png",
  send: "messager/arrow-up@3x.png",
  circleExclamation: "messager/circle-exclamation@3x.png",
  block: "messager/block.svg",
  salePlaceholder: "messager/sale-placeholder@3x.png",
  emptyState: "messager/empty-state@3x.png",
  check: "messager/check@3x.png",
  leave: "messager/leave@3x.png",
  bell: "messager/bell@3x.png",
  bellOff: "messager/bell-off.svg",
  lockOpen: "messager/lock-open@3x.png",
  download: "messager/download@3x.png",
  phone: "messager/phone@3x.png",
  personIcon: "messager/personIcon.svg",
  checkGreen: "messager/check-green@3x.png",
  fileIcon: "messager/fileIcon@3x.png",
  imageThumbnail: "messager/imageThumbnail@3x.png",
  leaveRed: "messager/leave-red@3x.png",
  downloadBlue: "messager/download-blue@3x.png",
  pending: "messager/pending@3x.png",
  closeRed: "messager/close-red@3x.png",
  reload: "messager/reload@3x.png",
  failed: "messager/failed@3x.png",
  banIcon: "messager/icon-ban.svg",
  banOthersIcon: "messager/icon-ban-others.svg",
  alarm: "alarm-icon@3x.png",
  chatAlarmToastBell: "messager/chat-alarm-toast-bell@3x.png",
  dnd: "dnd-icon@3x.png",
};

const ovIconPaths = {
  exitConfirm: "/ov_exit_confirm.png",
};

const ICON_BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL || "/images";

const mapObject = (base_url, obj, prefix = "") =>
  Object.fromEntries(
    Object.entries(obj).map(
      ([key, value]) =>
        typeof value === "string"
          ? [key, `${base_url}${prefix}${value}`]
          : [key, mapObject(base_url, value, prefix)] // 중첩 객체 처리
    )
  );

const icons = mapObject(ICON_BASE_URL, iconPaths, "/icon/");
icons.messager = mapObject(ICON_BASE_URL, messagerIconPaths, "/icon/");
icons.ov = mapObject(ICON_BASE_URL, ovIconPaths, "/icon/");
export default icons;
